import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function getToken() {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}
export function setToken(t, remember) {
  clearToken();
  if (remember) localStorage.setItem("token", t);
  else sessionStorage.setItem("token", t);
}
export function clearToken() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto sign-out when the session is invalidated (e.g. logged in on another device)
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/login") && getToken()) {
      clearToken();
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (path) =>
  path ? `${API}/files/${path}?auth=${getToken()}` : "";

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.path;
}

export async function uploadFilePublic(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload/public", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.path;
}

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Đã xảy ra lỗi, vui lòng thử lại.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
}
